"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const ButtonBase_1 = __importDefault(require("@mui/material/ButtonBase"));
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const FlashOn_1 = __importDefault(require("@mui/icons-material/FlashOn"));
const Add_1 = __importDefault(require("@mui/icons-material/Add"));
const CloudUpload_1 = __importDefault(require("@mui/icons-material/CloudUpload"));
const FilterListRounded_1 = __importDefault(require("@mui/icons-material/FilterListRounded"));
const GetApp_1 = __importDefault(require("@mui/icons-material/GetApp"));
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const QIconButton_1 = __importDefault(require("components/QIconButton"));
const SearchBox_1 = __importDefault(require("components/SearchBox"));
const FileImportDialog_1 = __importDefault(require("components/Dialogs/FileImportDialog"));
const QFilterSelect_1 = __importDefault(require("components/QFilterSelect"));
const useQCurrency_1 = __importDefault(require("components/QCurrency/useQCurrency"));
const useQDialogs_1 = __importDefault(require("components/QDialogs/useQDialogs"));
const QButton_1 = __importDefault(require("components/QButton"));
const react_device_detect_1 = require("react-device-detect");
const types_1 = require("components/QFilterSelect/types");
const utils_1 = require("components/QFilterSelect/utils");
const scheduleViewMenu_1 = __importDefault(require("./scheduleViewMenu"));
const SearchHelpBox_1 = __importDefault(require("./SearchHelpBox"));
const styles_1 = require("./styles");
const QTip_1 = __importDefault(require("../../QuickenControls/QTip"));
const useStyles = (0, mui_1.makeStyles)()(styles_1.styles);
const RegControlBar = ({ onFastCategorize, scheduledTransactionsInRegister, accountsFilter, filterObject, filter, transactionListMetrics, onSearch, showNewTxn, showDebtErrorMessage, isWindowsDataset, onReminderChange, downloadFile, onApplyFilter, acctTxns, noNew, reminderSetting, showAdvancedFilter, }) => {
    var _a;
    const { classes, theme } = useStyles();
    const { formatAmount, getSharedCurrency } = (0, useQCurrency_1.default)();
    const { dialogAlert } = (0, useQDialogs_1.default)();
    const { datasetPreferences } = (0, useQPreferences_1.default)();
    const isAutoSearchEnabled = ((_a = datasetPreferences === null || datasetPreferences === void 0 ? void 0 : datasetPreferences.transactionRegister) === null || _a === void 0 ? void 0 : _a.autoSearch) || false;
    const [activeSearch, setActiveSearch] = (0, react_1.useState)(!!(filter === null || filter === void 0 ? void 0 : filter.trim()));
    const [showHelp, setShowHelp] = (0, react_1.useState)(false);
    const [showFileImportDialog, setShowFileImportDialog] = (0, react_1.useState)(false);
    const [filterAnchorEl, setFilterAnchorEl] = (0, react_1.useState)(null);
    const [cancellingFilter, setCancellingFilter] = (0, react_1.useState)(false);
    const searchRef = (0, react_1.useRef)(null);
    const csvImport = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlag(state, 'csvImport'));
    const transactionFilters = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlag(state, 'transactionFilters'));
    const isEntityShareEnableUser = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isEntityShareUser);
    const excludedResourceTypes = showAdvancedFilter ? [] : ['advanced'];
    (0, react_1.useEffect)(() => {
        if (filter !== undefined && filter.trim() !== '') {
            setActiveSearch(true);
        }
        else {
            setActiveSearch(false);
        }
    }, [filter]);
    const handleSearch = (string) => {
        if (string !== null) {
            setActiveSearch(string.trim().length > 0);
            onSearch(string.trim());
        }
    };
    const handleDownloadFile = () => {
        if (downloadFile) {
            downloadFile();
        }
    };
    const applyFilter = (filters) => {
        setFilterAnchorEl(null);
        onApplyFilter(filters);
    };
    const cancelFilters = (e) => {
        e.stopPropagation();
        setCancellingFilter(true);
        setTimeout(() => {
            onApplyFilter(new types_1.FilterObject());
            setCancellingFilter(false);
        }, 10);
    };
    // If searching
    const { numTxns, sumTxns } = transactionListMetrics;
    const currSymbol = getSharedCurrency(acctTxns);
    const totalText = formatAmount(sumTxns, currSymbol);
    const selText = ` (${numTxns} Transaction${numTxns > 1 ? 's' : ''} Found: ${totalText})`;
    // have to break into the object and count the size of each Set
    const numFilterItems = (0, utils_1.countFilterItemsForDisplay)(filterObject) + ((filterObject === null || filterObject === void 0 ? void 0 : filterObject.get('payees').size) || 0);
    return (<>
      {showHelp && searchRef &&
            <SearchHelpBox_1.default classes={classes} anchorEl={searchRef.current} onClose={() => setShowHelp(false)}/>}

      {filterAnchorEl &&
            <QFilterSelect_1.default onApply={applyFilter} initialFilter={filterObject} popover openPopoverProps={{
                    transformOrigin: {
                        horizontal: 'left',
                        vertical: 'top',
                    },
                }} anchorEl={filterAnchorEl} onClose={() => setFilterAnchorEl(null)} excludedResourceTypes={excludedResourceTypes}/>}

      <div className={classes.container}>
        <Typography_1.default className={classes.title} variant="h6" noWrap>
          Transaction Activity
        </Typography_1.default>

        {(activeSearch || numFilterItems > 0) &&
            <Typography_1.default variant="body2" id="reg-header-search-total" className={classes.searchMetrics}>
            {selText}
          </Typography_1.default>}


        <div className={classes.searchContainer} ref={(x) => { searchRef.current = x; }}>

          <div className={classes.rightControls}>
            <div className={classes.searchBox} style={{ borderColor: filterAnchorEl != null ? theme.palette.primary.main : '' }}>
              <SearchBox_1.default onSearch={handleSearch} initialValue={filter} autoSearch={isAutoSearchEnabled} autoFocus onHelp={setShowHelp}/>
            </div>
            {transactionFilters &&
            <div className={classes.filterBox} style={{ borderColor: filterAnchorEl != null ? theme.palette.primary.main : '' }}>
                <QIconButton_1.default style={{ color: filterAnchorEl != null ? theme.palette.primary.main : '' }} aria-label="Transaction Filters" onClick={(e) => setFilterAnchorEl(filterAnchorEl ? null : e.currentTarget)} id="reg-add-filter" IconComponent={FilterListRounded_1.default} IconProps={{ className: classes.filterIconButton }} tooltip="Filter List" size="small-target"/>
                <Typography_1.default variant="body2" className={classes.filterNum} id="reg-add-filter" onClick={(e) => setFilterAnchorEl(filterAnchorEl ? null : e.currentTarget)}>
                  {numFilterItems}
                </Typography_1.default>
                {numFilterItems > 0 &&
                    <ButtonBase_1.default className={classes.filterNumClose} onClick={cancelFilters}>
                    {cancellingFilter ? '' : <Typography_1.default className={classes.filterNumCloseText} variant="body2"> X </Typography_1.default>}
                  </ButtonBase_1.default>}
              </div>}
          </div>
          <div className={classes.iconDivider} style={{ minWidth: !(react_device_detect_1.isMobile || react_device_detect_1.isTablet) && csvImport ? 66 : 34 }}>
            {csvImport &&
            <>
                <QIconButton_1.default aria-label="Import transactions" id="import-transactions-button" IconComponent={CloudUpload_1.default} IconProps={{ className: classes.iconButton }} onClick={(_e) => {
                    setShowFileImportDialog(true);
                }} tooltip="Import transactions" size="medium-no-padding"/>
                <FileImportDialog_1.default account={accountsFilter.first()} open={Boolean(showFileImportDialog)} onHandleClose={() => setShowFileImportDialog(false)}/>
              </>}

            {!(react_device_detect_1.isMobile || react_device_detect_1.isTablet) &&
            <QIconButton_1.default aria-label="Download transactions" id="reg-fast-download-csv" IconComponent={GetApp_1.default} IconProps={{ className: classes.iconButton }} onClick={handleDownloadFile} tooltip="Download transactions" size="small-target"/>}
          </div>

          {scheduledTransactionsInRegister && !isEntityShareEnableUser &&
            <div className={classes.scheduleMenuHolder}>
              {onReminderChange &&
                    <scheduleViewMenu_1.default reminderSetting={reminderSetting} onChange={onReminderChange} isWindows={isWindowsDataset}/>}
            </div>}

          {onFastCategorize && !noNew &&
            <QIconButton_1.default aria-label="Categorize transactions" id="reg-fast-categorize-all" IconComponent={FlashOn_1.default} IconProps={{ className: classes.iconButton }} onClick={onFastCategorize} tooltip="Automatically categorize uncategorized transactions when a suggestion is available" size="small-target"/>}

          {!noNew &&
            <QTip_1.default title="Add transaction">
              <QButton_1.default variant="contained" id="txn-register-add-txn-button" className={classes.addTxnButton} aria-label="Add" onClick={(e) => {
                    e.stopPropagation();
                    if (showDebtErrorMessage) {
                        dialogAlert('Unsupported Feature', 'You may only add, modify or delete loan account transactions on the desktop app', undefined, ['OK']);
                        return;
                    }
                    showNewTxn();
                }}>
                <Add_1.default />
              </QButton_1.default>
            </QTip_1.default>}
        </div>
      </div>
    </>);
};
exports.default = RegControlBar;
